<template>
    <div class="ProblemsListEditor">
        <div class="container-fluid">
            <b-row>
                <b-col>
                    <h4>Problems List: <a target="_blank" :href="'/API/MentalHealth/Clients/ClientMHProblems/ProblemsReport?ClientSubProgramMembershipID=' + ChartId"><i class="fa fa-download" /></a></h4>
                </b-col>
            </b-row>
            <b-row style="overflow-x:auto;">
                <b-col cols="11">
                    <vuetable :fields="Fields"
                              :data="FieldData"
                              pagination-path=""
                              :api-mode="false"
                              class="vue-datatable">

                        <template slot="DetailView" scope="props">
                            <div v-if="EditMode" class="DetailView">
                                <span class="underline pointer" @click="ShowDetail(props.rowData)"><span v-html="props.rowData.DiagnosticDescription"></span> <font-awesome-icon :icon="['fa', 'edit']" v-if="EditMode" /></span>
                            </div>
                            <div v-else class="DetailView">
                                <span v-html="props.rowData.DiagnosticDescription"></span>
                            </div>
                        </template>
                    </vuetable>
                </b-col>
                <b-col cols="1">
                    <div v-if="EditMode && CheckPermission(EditPermission)" class="vert-icons">
                        <b-row>
                            <font-awesome-icon :icon="['fa', 'plus']" v-on:click="ShowNewDetail()" class="pointer olive-green-text" />
                        </b-row>
                    </div>
                </b-col>
            </b-row>
        </div>

        <!--MODALS-->
        <b-modal ref="detail-modal" size="lg" title="Problems List Item" hide-footer :scrollable="true">
            <b-container>
                <b-form @submit="CreateEditProblem">
                    <b-row>
                        <b-col>
                            <div class="form-group">
                                <label>Problem:</label>
                                <v-select @search="GetMHProblemOptions" required :options="ProblemOptions" label="CodeDescription" :reduce="option => option.Id" v-model="TargetRecord.DiagnosticCodeID" @input="SetCodeAndDescription">
                                    <template #search="{attributes, events}">
                                        <input class="vs__search"
                                               :required="!TargetRecord.DiagnosticCodeID"
                                               v-bind="attributes"
                                               v-on="events" />
                                    </template>
                                </v-select>
                            </div>
                            <div class="form-group">
                                <label>Code:</label>
                                <input type="text" readonly class="form-control" v-model="TargetRecord.DiagnosticCode" required />
                            </div>
                            <div class="form-group">
                                <label>Description:</label>
                                <textarea rows="5" readonly class="form-control" v-model="TargetRecord.DiagnosticDescription" required />
                            </div>
                            <!--<div class="form-group">
                                <label>Problem Type:</label>
                                <select class="form-control" v-model="TargetRecord.ProblemType" required>
                                    <option value=""></option>
                                    <option value="Chronic">Cronic</option>
                                    <option value="Acute">Acute</option>
                                    <option value="Disability">Disability</option>
                                    <option value="Unassigned">Unassigned</option>
                                </select>
                            </div>-->
                            <div class="form-group">
                                <label>Problem Context:</label>
                                <select class="form-control" v-model="TargetRecord.ProblemContext" required>
                                    <option value=""></option>
                                    <option value="Principal Diagnosis">Principal Diagnosis</option>
                                    <option value="Clinical Disorders Related to Treatment">Clinical Disorders Related to Treatment</option>
                                    <option value="Admitting Diagnosis">Admitting Diagnosis</option>
                                    <option value="Other Conditions that may be the Focus of Clinical Attention">Other Conditions that may be the Focus of Clinical Attention</option>
                                    <option value="External Cause of Injury">External Cause of Injury</option>
                                    <option value="Patient's Reason for Visit">Patient's Reason for Visit</option>
                                </select>
                            </div>
                        </b-col>
                        <b-col>
                            <div class="form-group">
                                <label>Problem Status:</label>
                                <select class="form-control" v-model="TargetRecord.Status" required>
                                    <option value=""></option>
                                    <option value="Current">Current</option>
                                    <option value="At Risk For">At Risk For</option>
                                    <option value="Resolved/Inactive">Resolved/Inactive</option>
                                </select>
                            </div>

                            <div class="form-group">
                                <label>Date Identified:</label>
                                <flat-pickr v-model="TargetRecord.DateReported" class="form-control" required :config="DateConfig"></flat-pickr>
                            </div>
                            <div class="form-group">
                                <label>Identified By: (include professional title)</label>
                                <input type="text" class="form-control" v-model="TargetRecord.ReportingEmployeeName" required />
                            </div>
                            <div class="form-group">
                                <label>Date Added:</label>
                                <flat-pickr v-model="TargetRecord.DateAdded" class="form-control" required :config="DateConfig"></flat-pickr>
                            </div>
                            <div class="form-group">
                                <label>Date Resolved:</label>
                                <flat-pickr v-model="TargetRecord.DateResolved" class="form-control" :config="DateConfig"></flat-pickr>
                            </div>
                            <div class="form-group">
                                <label>Resolved By: (include professional title)</label>
                                <input type="text" class="form-control" v-model="TargetRecord.ResolvingEmployeeName" />
                            </div>
                        </b-col>
                    </b-row>
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">

                            <b-button size="md" variant="secondary" @click="CancelDetail()">
                                CANCEL
                            </b-button>
                            <b-button size="md" variant="success" type="submit">
                                SAVE
                            </b-button>
                            <b-button v-if="TargetRecord.Id" size="md" variant="danger" @click="DeleteProblem()">
                                DELETE
                            </b-button>
                        </div>
                    </b-row>
                </b-form>
            </b-container>
        </b-modal>
    </div>
</template>

<script>
    //import components
    import Vuetable from 'vuetable-2/src/components/Vuetable';
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    import vSelect from 'vue-select'
    import 'vue-select/dist/vue-select.css';

    export default {
        name: "ProblemsListEditor",
        props: [
            'ChartId',
            'EditMode'
        ],
        data: function () {
            return {
                TargetRecord: {},
                FieldData: [],
                Fields: [
                    {
                        name: 'DiagnosticCode',
                        title: "Problem/Diagnosis",
                    },
                    {
                        name: "__slot:DetailView",
                        title: "Description",
                        sortField: 'DiagnosticDescription'
                    },
                    {
                        name: 'TypeContextStatus',
                        title: "Context/Status",
                    },
                    {
                        name: 'DateAdded',
                        title: "Added",
                        callback: 'formatDate|MM/DD/YY',
                    },
                    {
                        name: 'ReportingEmployeeName',
                        title: "Identified By",
                    },
                    {
                        name: 'DateReported',
                        title: "Identified",
                        callback: 'formatDate|MM/DD/YY',
                    },
                    {
                        name: 'ResolvingEmployeeName',
                        title: "Resolved By",
                    },
                    {
                        name: 'DateResolved',
                        title: "Resolved",
                        callback: 'formatDate|MM/DD/YY',
                    },
                ],
                DateConfig: {
                    dateFormat: 'Y-m-d',
                    allowInput: true,
                    altInput: true,
                    altFormat: 'm/d/Y',
                },
                ProblemOptions: [
                    
                ],
                loader: null
            };
        },
        methods: {
            GetData() {
                this.$MasterAPI.ExecuteRequest("GET", "MentalHealth/Clients/ClientMHProblems", { ClientSubProgramMembershipID: this.ChartId }, this.GetDataSuccess, () => { }, false);
            },
            GetDataSuccess(response) {
                this.FieldData = response.data.data;
            },
            GetMHProblemOptions(search, loading) {
                this.loader = loading;
                this.loader(true);
                this.$MasterAPI.ExecuteRequest("GET", "MentalHealth/Clients/ClientMHProblems/ProblemsOptions", { Search: search }, this.GetMHProblemOptionsSuccess, () => { }, false);
            },
            GetMHProblemOptionsSuccess(response) {
                this.loader(false);
                this.ProblemOptions = response.data.data;
            },
            formatDate(value, fmt = 'MM/DD/YY', defaultText = '') {
                return (value == null)
                    ? defaultText
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            ShowNewDetail() {
                //this.GetMHProblemOptions()
                this.TargetRecord = {};
                this.$refs["detail-modal"].show();
            },
            ShowDetail(problem) {
                //this.GetMHProblemOptions()
                this.TargetRecord = JSON.parse(JSON.stringify(problem));
                let vm = this;
                for (let i = 0; i < vm.ProblemOptions.length; i++) {
                    if (vm.ProblemOptions[i].Id == vm.TargetRecord.DiagnosticCodeID) {
                        vm.TargetRecord.ProblemId = vm.ProblemOptions[i].Id;
                        break;
                    }
                }
                this.$refs["detail-modal"].show();
            },
            CancelDetail() {
                this.$refs["detail-modal"].hide();
            },
            CreateEditProblem(e) {
                e.preventDefault();
                this.TargetRecord.ClientSubProgramMembershipID = this.ChartId;
                this.$MasterAPI.ExecuteRequest("PUT", "MentalHealth/Clients/ClientMHProblems", this.TargetRecord, this.CreateEditProblemSuccess, () => { }, true);
            },
            CreateEditProblemSuccess(response) {
                this.GetData();
                this.$refs["detail-modal"].hide();
            },
            DeleteProblem() {
                this.$MasterAPI.ExecuteRequest("DELETE", "MentalHealth/Clients/ClientMHProblems/" + this.TargetRecord.Id, {}, this.DeleteProblemSuccess, () => { }, true);
            },
            DeleteProblemSuccess(response) {
                this.GetData();
                this.$refs["detail-modal"].hide();
            },
            SetCodeAndDescription() {
                let vm = this;
                for (let i = 0; i < vm.ProblemOptions.length; i++) {
                    if (vm.ProblemOptions[i].Id == vm.TargetRecord.DiagnosticCodeID) {
                        vm.TargetRecord.DiagnosticCode = vm.ProblemOptions[i].DiagnosticCode;
                        vm.TargetRecord.DiagnosticDescription = vm.ProblemOptions[i].DiagnosticDescription;
                        break;
                    }
                }
            },
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            }

        },
        components: {
            Vuetable,
            flatPickr,
            vSelect
        },
        mounted() {
            this.GetData();
        },
        computed: {
        }
    }
</script>
